import React from "react";

const formatResultDate = (dateString) => {
    const date = new Date(dateString);
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    let hours = date.getHours();
    const minutes = String(date.getMinutes()).padStart(2, "0");
    const ampm = hours >= 12 ? "PM" : "AM";
    hours = hours % 12 || 12;
    return `${month}/${day}, ${String(hours).padStart(2, "0")}:${minutes} ${ampm}`;
};

const SuperOverT20Result = ({ resultData = [] }) => {

    const getCards = (cards) => {
        if (!cards) return [];
        return cards.split(",").filter(Boolean);
    };

    return (
        <div className="left-content">

            {resultData.map((row, index) => {

                const team1Winner = row.result === "1";
                const team2Winner = row.result === "2";

                const resultParts = (row.resultTxt || "").split(",").map(item => item.trim());

                const matchWinner = resultParts[0];
                const wicketWinner = [row.rnr3, row.rnr4].find(item => item === resultParts[1]);
                const boundaryWinner = [row.rnr5, row.rnr6].find(item => item === resultParts[2]);

                const players = [
                    {
                        label: row.rnr1,
                        cards: getCards(row.c1),
                        winner: matchWinner === row.rnr1
                    },
                    {
                        label: row.rnr2,
                        cards: getCards(row.c2),
                        winner: matchWinner === row.rnr2
                    },
                    ...(wicketWinner ? [{
                        label: wicketWinner,
                        cards: [],
                        winner: true
                    }] : []),
                    ...(boundaryWinner ? [{
                        label: boundaryWinner,
                        cards: [],
                        winner: true
                    }] : [])
                ];

                return (

                    <div
                        key={index}
                        className="card"
                        style={{
                            border: "1px solid #ccc",
                            borderRadius: "8px",
                            padding: "10px",
                            marginBottom: "8px",
                            background:
                                "linear-gradient(rgb(15,15,15), rgb(251,251,251))"
                        }}
                    >

                        <div
                            style={{
                                fontWeight: "bold",
                                fontSize: "16px",
                                marginBottom: "10px",
                                marginTop: "7px",
                                marginLeft: "7px",
                            }}
                        >
                            {formatResultDate(row.evt_od)} - <b>ID=</b> {row._id}
                        </div>

                        <div
                            style={{
                                display: "flex",
                                flexWrap: "wrap",
                                gap: "3px"
                            }}
                        >

                            {players.map((player, i) => (

                                <div
                                    key={i}
                                    style={{
                                        width:
                                            i === 0 || i === 3
                                                ? "100%"
                                                : "calc(50% - 4px)",
                                        borderRadius: "10px",
                                        overflow: "hidden",
                                        background: player.winner ? "#008d00" : "#444"
                                    }}
                                >
                                    <div
                                        style={{
                                            color: "#fff",
                                            textAlign: "center",
                                            fontWeight: "bold",
                                            fontSize: "16px"
                                        }}
                                    >
                                        {player.label}
                                    </div>

                                    <div
                                        style={{
                                            display: "flex",
                                            justifyContent: "center",
                                            alignItems: "center",
                                            flexWrap: "nowrap",
                                            minHeight: "55px",
                                            overflowX: "hidden"
                                        }}
                                    >

                                        {player.cards.length > 0 ? (

                                            player.cards.map((card, idx) => (

                                                <img
                                                    key={idx}
                                                    src={`/assets/images/cards/${card}.svg`}
                                                    alt={card}
                                                    draggable={false}
                                                    style={{
                                                        width: "38px",
                                                        marginLeft: "-5px"
                                                    }}
                                                />

                                            ))

                                        ) : (

                                            <div className="open_cardTP sprite-card-chs-card svg-card_simple_1-dims d-card trans_10 svg-card_simple_omaha_back_bf"></div>

                                        )}

                                    </div>

                                    <div
                                        style={{
                                            background: player.winner
                                                ? "#d8942a"
                                                : "#d64040",
                                            color: "#000",
                                            textAlign: "center",
                                            fontWeight: "bold",
                                            fontSize: "16px",
                                            borderRadius: "10px"
                                        }}
                                    >
                                        {player.winner ? "WINNER" : "LOSER"}
                                    </div>

                                </div>

                            ))}

                        </div>

                    </div>

                );

            })}

        </div>
    );
};

export default SuperOverT20Result;